import React, { useState } from "react";
import { handleNotify } from "../store/layout/actions";
import { useDispatch } from "react-redux";

const ContactUs = () => {
  const initial = {
    fname: "",
    lname: "",
    email: "",
    phone: "",
    message: "",
  };
  const [formData, setFormData] = useState(initial);

  const dispatch = useDispatch();
  const handlerSubmit = (e) => {
    e.preventDefault();
    handleNotify(
      true,
      `${formData?.fname}, Thanks for send us a message... our team will get back to you soon`
    )(dispatch);
    setFormData(initial);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <div className="bg-gray-100 dark:bg-primary-darkBg min-h-[calc(100vh-200px)] flex items-center flex-col py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl">
        <div className="flex items-center flex-col mx-auto">
          <h3>Contact Us</h3>
          <p className="text-xl text-primary-text dark:text-default font-normal mb-8">
            Have any questions? We'd love to hear from you.
          </p>
        </div>
        <div className="w-full bg-white dark:bg-[#1a1d1f] rounded-lg shadow-lg p-3 md:p-6 flex flex-col lg:flex-row gap-6">
          <div className="text-white p-4 rounded-lg flex flex-col justify-between w-full lg:w-1/2">
            <div>
              <h2 className="text-2xl font-bold mb-2">Contact information</h2>
              <p className="text-lg">
                Fill out the form and our team will get back to you soon.
              </p>
            </div>
            <div className="mt-8 space-y-4">
              <div className="flex items-center space-x-2">
                <span className="material-icons">Phone</span>
                <span>+1 (000) 00-00000</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="material-icons">Email</span>
                <span>contact@goodvibz.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="material-icons">Help</span>
                <span>Help Center</span>
              </div>
            </div>
          </div>

          <form
            className="w-full lg:w-1/2 space-y-4"
            method="POS"
            onSubmit={handlerSubmit}
          >
            <div className="flex flex-col md:flex-row gap-4">
              <div className="md:w-1/2">
                <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                  First Name*
                </label>
                <input
                  type="text"
                  name="fname"
                  value={formData.fname}
                  onChange={handleChange}
                  className="mt-1 px-2 py-3 block w-full border border-gray-300 dark:bg-[#272b30] rounded-md shadow-sm outline-none sm:text-sm text-white"
                  required
                />
              </div>
              <div className="md:w-1/2">
                <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                  Last Name*
                </label>
                <input
                  type="text"
                  name="lname"
                  value={formData.lname}
                  onChange={handleChange}
                  className="mt-1 px-2 py-3 block w-full border border-gray-300 rounded-md dark:bg-[#272b30] shadow-sm outline-none sm:text-sm text-white"
                  required
                />
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4">
              <div className="md:w-1/2">
                <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                  Email*
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="mt-1 px-2 py-3 block w-full border border-gray-300 rounded-md dark:bg-[#272b30] shadow-sm sm:text-sm outline-none text-white"
                  required
                />
              </div>
              <div className="md:w-1/2">
                <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                  Phone*
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="mt-1 px-2 py-3 block w-full border border-gray-300 rounded-md dark:bg-[#272b30] shadow-sm sm:text-sm outline-none text-white"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                Message*
              </label>
              <textarea
                rows="4"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="mt-1 p-2 block w-full border border-gray-300 rounded-md dark:bg-[#272b30] shadow-sm sm:text-sm outline-none text-white"
                placeholder="About"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-primary text-white font-bold py-2 px-4 rounded-md transition-colors text-center"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
